/**
 * Creates a debounced version of a function.
 *
 * @param fn The function to debounce
 * @param wait The time in milliseconds to delay
 * @returns A debounced version of the input function with the same signature
 */
export default function debounce<T extends (...args: any[]) => any>(fn: T, wait: number): (...args: Parameters<T>) => void {
	let timeoutId: ReturnType<typeof setTimeout> | null = null;

	return function (this: any, ...args: Parameters<T>): void {
		const context = this;

		if (timeoutId != null) {
			clearTimeout(timeoutId);
		}

		timeoutId = setTimeout(() => {
			fn.apply(context, args);
			timeoutId = null;
		}, wait);
	};
}
